import style from "./style.less";
import React, { useEffect, useRef, useState } from "react";
import { Flex, FloatingBall } from "react-vant";
import { GetDownloadApkUrl } from "@/data/urls";
import { PersistContext } from "@/data/PersistProvider";
import { LocalConfig, NumericalConfig } from "@/config";
import MyNavLink from "../MyNavLink";

const copyText = (text, callback) => {
  // text:  ， callback:
  let tag = document.createElement("input");
  tag.setAttribute("id", "cp_hgz_input");
  tag.value = text;
  document.getElementsByTagName("body")[0].appendChild(tag);
  document.getElementById("cp_hgz_input").select();
  document.execCommand("copy");
  document.getElementById("cp_hgz_input").remove();
  if (callback) {
    callback(text);
  }
};
const DownloadFloatBall = (props) => {
  const { getPersist } = React.useContext(PersistContext);
  //悬浮效果
  const DownloadImg = () => {
    const [count, setCount] = useState(0);
    const timer = useRef(null);
    useEffect(() => {
      if (timer.current != null) {
        clearTimeout(timer.current);
        timer.current = null;
      }
      timer.current = setTimeout(() => {
        if (count == 9) {
          setCount(0);
          return;
        }
        setCount(() => count + 1);
      }, 200);
      return () => {
        clearTimeout(timer.current);
      };
    }, [count]);
    return React.useMemo(
      () => (
        <div class={style.float_ball}>
          <div class={style.float_des}>
            <div class={style.float_img}>
              <img src={LocalConfig.downloadFloatImg} style={{ display: "inherit", width: "100%" }} />
            </div>
          </div>
        </div>
      ),
      [count]
    );
  };
  const onDownload = () => {
    let copyObj = {};
    const aid = getPersist("agent_rid") ? getPersist("agent_rid") : "";
    if (aid) {
      copyObj.aid = aid;
    }
    const c = getPersist("channel") ? getPersist("channel") : "";
    if (aid) {
      copyObj.c = c;
    }
    let copyStr = JSON.stringify(copyObj);
    copyText(copyStr, () => {
      console.log("copy successful", copyStr);
    });
    console.log("DownloadApkUrl:", GetDownloadApkUrl(c))
    window.location.href = GetDownloadApkUrl(c);
  };

  console.log(props.floatBall);
  return (
    <div class={style.float_ball_container} style={{ display: props.floatBall ? "block" : "none" }}>
      <FloatingBall
        offset={{
          bottom: "25rem",
        }}
        adsorb={true}
      >
        <Flex align="center" justify="center" direction="column">
          <div onClick={() => { props.onClose && props.onClose() }} style={{ alignSelf: "flex-end", marginRight: ".5rem" }}>
            <img src={require("@/assets/images/download/float_close.png").default} />
          </div>
          <a href={"#"} onClick={() => onDownload()}>
            <DownloadImg />
          </a>
        </Flex>
      </FloatingBall>
    </div>
  );
};

export default DownloadFloatBall;
